import {isATaxableDeliveryOptionSelected} from '../../../selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import store from '../../../store/store.js';
import stringContainsOnlyChineseCharacters from './stringContainsOnlyChineseCharacters';

const chineseCharactersOnlyErrorPrefix = 'errors.formFields.chinese.only';

export default function chineseCharactersOnlyWhenTaxableSelected(fieldName) {
  return (value) => {
    if (isATaxableDeliveryOptionSelected(store.getState()) && !stringContainsOnlyChineseCharacters(value)) {
      if (fieldName) return `${chineseCharactersOnlyErrorPrefix}.${fieldName}`;
      return chineseCharactersOnlyErrorPrefix;
    }
  };
}
